module.exports = __webpack_public_path__ + "img/a_huo_manage2.6e437569.png";